module.exports = __webpack_public_path__ + "static/media/mastercard.796f612b.png";